const inferenceProviderAliases = {
  amazon: 'aws',
  anthropicaws: 'anthropic-aws',
  bedrock: 'aws',
  claudeaws: 'anthropic-aws',
  fireworkai: 'fireworksai',
  fireworks: 'fireworksai',
  hf: 'huggingface',
  kimi: 'moonshotai',
  vertex: 'gcp',
  vertexai: 'gcp'
}

export const normalizeProviderId = id => String(id || '').trim().toLowerCase()

export const normalizeInferenceProviderId = id => {
  const normalized = normalizeProviderId(id)
  return inferenceProviderAliases[normalized] || normalized
}
